export default __webpack_public_path__ + "static/media/Pickpocket's Mask of the Final Way.3a1cd67a.jpg";